
import ProfileCircle from "../../../assets/filled/ProfileCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ProfileCircleIcon({ className, dataTestid = "ProfileCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ProfileCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
